import styled from 'styled-components';

export const Container = styled.div`
  display: relative;
`;

export const Ul = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const Img = styled.img`
  cursor: pointer;
`;
